<template>
  <AssayDescriptionGrid
    :dv="dv"
    :fields="fields"
    :validation-errors="validationErrors"
  />
  <component
    :is="runParametersComponent"
    v-if="runParametersComponent"
    :dv="dv"
  />
</template>

<script>
import { computed } from 'vue'
import {
  useMultiplexingValidation,
  useAssayVuelidate,
} from '@/composables/validation/assay/useAssayValidation'
import AssayDescriptionGrid from '../shared/AssayDescriptionGrid.vue'
import { CUSTOM_PROPERTIES } from '../../shared/fieldConstants.js'
import IlluminaRunParameters from './IlluminaRunParameters.vue'
import NanoporeRunParameters from './NanoporeRunParameters.vue'

const fields = [
  ['name'],
  ['slot:fc:id'],
  ['state', 'slot:fc:is_template'],
  ['multiplexed', 'nr_of_samples'],
  ['slot:fc:studies'],
  ['slot:fc:run_dir'],
  ['datasessions'],
  ['description'],
  CUSTOM_PROPERTIES,
  ['protocol_list'],
]

export default {
  name: 'AssaySequencing',
  components: {
    AssayDescriptionGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const { multiplexingError } = useMultiplexingValidation(props.dv)
    const { validationErrors } = useAssayVuelidate({
      multiplexed: multiplexingError,
    })

    const runParametersComponent = computed(() => {
      switch (props.dv.modelType?.toLowerCase()) {
        case 'ngsilluminaassay':
        case 'avitisequencingassay':
          return IlluminaRunParameters
        case 'nanoporeassay':
          return NanoporeRunParameters
        default:
          return null
      }
    })

    return {
      fields,
      validationErrors,
      runParametersComponent,
    }
  },
}
</script>
